import React, { useState } from "react";
import { Loader, Segment, Menu } from "semantic-ui-react";

import ChatSessionDetail from "../chat_sessions/ChatSessionDetail";
import EvaluatedCriteria from "../evaluation_sessions/EvaluatedCriteria";
import PartnerEvaluationComparison from "./PartnerEvaluationComparison";
import { 
	useFetchEvaluationSessionByIdQuery, 
	useFetchPartnerEvaluatedSessionByIdQuery 
} from "../evaluation_sessions/evaluationSessionApiSlice";
import PartnerEvaluationComparisonPerCriteria from "./PartnerEvaluationComparisonPerCriteria";

const PartnerEvaluationTabbedResult = ({ partner_session_id, evaluation_session_id }) => {
	// active detail to toggle each tab on the right pane
	const [selectedActiveTab, setSelectedActiveTab] = useState("tab_result");

	// load sessions data
  const { data: partner_data, isLoading: partner_loading } = useFetchPartnerEvaluatedSessionByIdQuery(partner_session_id);
	const { data: eos_data, isLoading: eos_loading } = useFetchEvaluationSessionByIdQuery(evaluation_session_id);

	if (partner_loading || eos_loading) {
		return (
			<div style={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
				<Segment attached="bottom" style={{ flex: 1, overflowY: 'auto' }}>
				  <Loader active />
				</Segment>
			</div>
		);
  } else {
		return (
			<div style={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
				<div style={{ display: 'flex', borderBottom: '1px solid rgba(34,36,38,.15)', backgroundColor: '#f9fafb' }}>
					<div 
						onClick={() => setSelectedActiveTab("tab_result")}
						style={{ 
							padding: '12px 20px', 
							cursor: 'pointer', 
							fontWeight: selectedActiveTab === "tab_result" ? '600' : 'normal',
							color: selectedActiveTab === "tab_result" ? '#007AFF' : 'rgba(0,0,0,0.6)',
							borderBottom: selectedActiveTab === "tab_result" ? '2px solid #007AFF' : 'none',
							marginBottom: '-1px',
							fontSize: '14px'
						}}
					>
						비교 결과
					</div>
					{/* <div 
						onClick={() => setSelectedActiveTab("tab_per_criteria")}
						style={{ 
							padding: '12px 20px', 
							cursor: 'pointer', 
							fontWeight: selectedActiveTab === "tab_per_criteria" ? '600' : 'normal',
							color: selectedActiveTab === "tab_per_criteria" ? '#007AFF' : 'rgba(0,0,0,0.6)',
							borderBottom: selectedActiveTab === "tab_per_criteria" ? '2px solid #007AFF' : 'none',
							marginBottom: '-1px',
							fontSize: '14px'
						}}
					>
						항목별 비교 결과
					</div> */}
					<div 
						onClick={() => setSelectedActiveTab("tab_chatsession")}
						style={{ 
							padding: '12px 20px', 
							cursor: 'pointer', 
							fontWeight: selectedActiveTab === "tab_chatsession" ? '600' : 'normal',
							color: selectedActiveTab === "tab_chatsession" ? '#007AFF' : 'rgba(0,0,0,0.6)',
							borderBottom: selectedActiveTab === "tab_chatsession" ? '2px solid #007AFF' : 'none',
							marginBottom: '-1px',
							fontSize: '14px'
						}}
					>
						응대 세션
					</div>
				</div>

				<div style={{ flex: 1, overflowY: 'auto', padding: '20px', overflowX: 'hidden' }}>
					{(() => {
						if (selectedActiveTab === "tab_chatsession") return <ChatSessionDetail chat_session_id={partner_data.chat_session.id} />;
						else if (selectedActiveTab === "tab_criteria") return <EvaluatedCriteria evaluatedcriterion_set={partner_data.partnerevaluatedcriterion_set} />;
						else if (selectedActiveTab === "tab_result") return <PartnerEvaluationComparison partner_evaluation_session={partner_data} eos_evaluation_session={eos_data}/>;
						else if (selectedActiveTab === "tab_per_criteria") return <PartnerEvaluationComparisonPerCriteria partner_evaluation_session={partner_data} eos_evaluation_session={eos_data}/>;
						else return 
					})()}
				</div>
			</div>
		);
  }
};

export default PartnerEvaluationTabbedResult;
